export default {
  kids: {
    background: "#f1f1f1",
    backgroundRGB: "241, 241, 241",
    color: {
      primary: "#614565",
      secondary: "#f1f1f1",
      secondaryRGB: "241, 241, 241",
      secondaryLight: "#e8e4f1"
    },
    components: {
      logo: {
        path:
          "M28.4,3.3 c-4.1,0.1-8.1,0.1-12.2,0c-2,0-4,0-6,0c-0.6,0-1.3,0-1.9,0.2C4.7,4.2,2.2,7,1.7,10.7c-0.4,3.2,1.2,6.1,4,7.6 c1.5,0.8,3,1.1,4.7,1.1c5.8,0,11.5,0,17.3,0c0.5,0,1,0,1.5,0c0.5,0.1,1,0.2,1.5,0.3c0.5,0.1,0.7,0.5,0.8,1 c0.2,0.9-0.1,1.6-0.8,2.1c-0.8,0.6-1.7,0.8-2.7,0.8c-5.4,0-10.7,0-16.1,0c-0.4,0-0.8,0-1.3-0.1c-1.5-0.2-2.6-1.2-2.9-2.5 c0-0.2-0.1-0.4-0.1-0.6h-6c0,0.1,0,0.2,0,0.3c0,0.2,0,0.3,0,0.5c0.2,1.6,0.6,3,1.5,4.3c1.8,2.6,4.1,4.1,7.4,4.1 c3.6,0,7.2,0,10.8,0c2.6,0,5.2,0,7.7,0c0.8,0,1.5-0.1,2.3-0.3c3.6-1,6.1-4.3,6.1-8.1c0-3.3-1.8-5.8-4.8-6.9 c-1.2-0.5-2.5-0.6-3.8-0.6c-5.9,0-11.9,0-17.8,0c-0.4,0-0.8,0-1.1,0c-0.6-0.1-1.1-0.2-1.6-0.5C7.8,13,7.5,12.5,7.5,12 c-0.1-0.9,0.2-1.6,1-2.1c0.7-0.5,1.5-0.6,2.3-0.6c1.3,0,2.6,0,4,0c4.1,0,8.3,0,12.4,0c0.5,0,1,0,1.5,0.1c1.3,0.3,2.3,1,2.7,2.4 c0.1,0.2,0.1,0.4,0.1,0.7h6c0-1.3-0.3-2.4-0.7-3.5c-1.1-2.7-3.8-5.7-8.2-5.7C28.6,3.3,28.5,3.3,28.4,3.3 M106.9,13.7 c2.6,0,4.3,1.7,4.3,4.4c0,0.6,0,1.3-0.1,1.9c-0.3,2.1-1.9,3.5-4,3.5c-4.5,0-16,0-20.6,0c-2.4,0-4.2-1.9-4.2-4.3 c0-0.7,0-1.4,0.1-2.1c0.3-1.9,1.9-3.3,3.8-3.5c0.3,0,0.7,0,1,0c2,0,4.1,0,6.1,0C95.6,13.7,104.8,13.7,106.9,13.7 M93.2,7.7 L93.2,7.7c-2.8,0-5.7,0-8.5,0c-0.5,0-1.1,0-1.6,0.1c-4,0.8-6.7,4.1-6.7,8.1c0,1.8,0,3.6,0,5.4c0,0.5,0,0.9,0.1,1.4 c0.7,4,4,6.9,8.1,6.9c5.7,0,18.5,0,24.2,0c0.7,0,1.5-0.1,2.2-0.2c3.5-0.7,6-3.6,6.3-7.1c0.1-2.2,0.1-4.4,0-6.7 c0-1.5-0.5-3-1.4-4.2c-1.6-2.4-3.9-3.6-6.7-3.7c-1.2,0-3.4,0-5.9,0C99.4,7.7,95.1,7.7,93.2,7.7 M39.6,0.4v29.2h6v-0.5 c0-4.1,0-8.3,0-12.5c0-0.9,0.3-1.4,1.1-1.8c1.5-0.7,3-1.1,4.7-1.1c4.1,0,8.3,0,12.4,0c0.5,0,1,0,1.5,0.1c1.3,0.2,2.3,0.8,2.7,2.1 c0.2,0.6,0.3,1.3,0.3,1.9c0,3.7,0,7.5,0,11.2v0.5h6V29c0-4.4,0-8.8,0-13.2c0-0.5,0-0.9-0.1-1.4c-0.5-3.7-3.9-6.9-7.6-6.9 c-4.7-0.1-9.4,0-14.2,0c-1.7,0-3.4,0.5-4.8,1.5c-0.8,0.6-1.5,1.3-1.8,2.2c-0.2,0.6-0.2,0.6-0.8,0.4c0.2-3.8,0.5-7.7,0.7-11.5h-6.1 V0.4z M128.9,23.5v-9.6c0-0.7,0.7-1.3,1.4-1l18.4,4.8c0.9,0.3,0.9,1.6,0,2l-18.4,4.8c-0.1,0-0.3,0.1-0.4,0.1 C129.4,24.5,128.9,24.1,128.9,23.5 M127.3,7.7c-0.4,0-0.8,0-1.2,0.1c-4,0.8-6.7,4.1-6.7,8.1c0,1.8,0,3.6,0,5.4 c0,0.5,0,0.9,0.1,1.4c0.7,4.1,4,6.9,8.2,6.9c2.5,0,7.8,0,12.6,0c3.5,0,6.8,0,8.6,0c1.1,0,2.2-0.1,3.2-0.5c1.9-0.6,3.6-1.6,4.2-3.8 h0.7c-0.2,3.9-0.5,14.7-0.7,18.5h6V7.7h-6c0.2,1.7,0.5,3.3,0.7,4.9h-0.7c-0.2-1.1-0.8-2-1.5-2.7c-1.5-1.4-3.4-2.2-5.5-2.2 c-1.9,0-5.2,0-8.8,0C135.4,7.7,130,7.7,127.3,7.7",
        viewBox: "0 0 566.3 56.8",
        width: "42.95vw",
        height: "3.3vw",
        color: "#614565"
      },
      carousel: {
        shadowBorderWidth: "6px",
        borderRadius: "18px"
      },
      image: {
        fallback: {
          icon: "playStroke",
          iconColor: "#614565",
          color: "#614565",
          backgroundColor: "#e8e4f1"
        }
      },
      arrowScroll: {
        font: {
          color: "#614565"
        },
        icon: {
          color: "#614565"
        }
      },
      progress: {
        backgroundColor: "#614565",
        backgroundPlaybackLight: "#ce9ffc",
        backgroundPlaybackDark: "#614565"
      },
      poster: {
        episode: {
          color: "#261e32",
          figcaption: {
            color: "#f1f1f1"
          }
        }
      },
      detail: {
        heading: {
          color: "#261e32"
        },
        synopsis: {
          color: "#261e32"
        },
        info: {
          color: "#585360"
        },
        data: {
          color: "#585360"
        }
      },
      button: {
        border: {
          colorFocused: "#614565"
        },
        font: {
          color: {
            primary: "#614565",
            secondary: "#614565"
          },
          colorFocused: {
            primary: "#f1f1f1",
            secondary: "#614565"
          },
          weight: {
            primary: 700,
            secondary: 300
          }
        },
        background: {
          color: {
            primary: "#e8e4f1",
            secondary: "#e8e4f1"
          },
          colorFocused: {
            primary: "#614565",
            secondary: "#e8e4f1"
          }
        },
        icon: {
          color: "#614565",
          colorFocused: {
            primary: "#f1f1f1",
            secondary: "#614565"
          }
        }
      },
      itemMainMenu: {
        background: "#e8e4f1",
        fontWeight: 700,
        icon: {
          color: "#614565"
        },
        secondaryIcon: {
          color: "#614565"
        }
      },
      itemSecondaryMenu: {
        color: {
          default: "#614565",
          focused: "#f1f1f1"
        },
        background: {
          focused: "#614565",
          selected: "#dfd2ff"
        }
      },
      keyboard: {
        key: {
          border: {
            color: "#f1f1f1"
          },
          background: {
            default: "#e8e4f1",
            focused: "#614565"
          },
          color: {
            default: "#614565",
            focused: "#f1f1f1"
          }
        }
      },
      input: {
        font: {
          color: {
            default: "#676d70",
            active: "#614565"
          }
        }
      },
      loading: {
        overlay: {
          colorRGB: "241 241 241"
        },
        icon: {
          color: "#614565"
        }
      },
      text: {
        color: {
          primary: "#614565"
        }
      },
      toast: {
        font: {
          color: "#614565",
          shadowColor: "#f1f1f1"
        },
        backgroundColor: "#e8e4f1",
        icon: {
          color: "#614565"
        }
      }
    }
  },
  disney: {
    background:
      "http://mena-img-cdn-lb.aws.playco.com/prd-peg-data/default/bigscreen/images/Themes/disney/background.jpg"
  }
};
